import(/* webpackMode: "eager" */ "/vercel/path0/app/docs/layout.tsx");
